import { TagType } from '../types/interfaces';

export const CharacteristicValueTemplate: TagType = {
  label: '',
  id: ''
};
